var DEFAULT_MIN_LABEL = 'min';
var DEFAULT_MAX_LABEL = 'max';
var DEFAULT_FALLBACK = { min: 0 };
var buildData = function (rangeData, asObject) {
    var _a;
    if (!asObject)
        return rangeData;
    var min = rangeData[0], max = rangeData[1];
    return _a = {},
        _a[(asObject === null || asObject === void 0 ? void 0 : asObject.min) || DEFAULT_MIN_LABEL] = min,
        _a[(asObject === null || asObject === void 0 ? void 0 : asObject.max) || DEFAULT_MAX_LABEL] = max,
        _a;
};
var addFallback = function (rangeData, fallback) {
    var validData = rangeData.filter(function (data) { return data !== undefined; });
    if (validData.length === 1) {
        if (fallback.max !== undefined) {
            validData.push(fallback.max);
        }
        else if (fallback.min !== undefined) {
            validData.unshift(fallback.min);
        }
    }
    return validData;
};
var rangeParser = function (options) {
    if (options === void 0) { options = {}; }
    var asObject = options.asObject, _a = options.separator, separator = _a === void 0 ? ':' : _a, _b = options.fallback, fallback = _b === void 0 ? DEFAULT_FALLBACK : _b;
    return {
        parse: function (data) {
            if (data === void 0) { data = ''; }
            if (!data.trim())
                return buildData([], asObject);
            var rangeData = addFallback(decodeURIComponent(data).split(separator).map(Number), fallback);
            return buildData(rangeData, asObject);
        },
        stringify: function (data) {
            if (data === undefined ||
                (Array.isArray(data) && !data.length) ||
                (!Array.isArray(data) && !Object.entries(data).length)) {
                return '';
            }
            var baseData = (!Array.isArray(data)
                ? [
                    data[(asObject === null || asObject === void 0 ? void 0 : asObject.min) || DEFAULT_MIN_LABEL],
                    data[(asObject === null || asObject === void 0 ? void 0 : asObject.max) || DEFAULT_MAX_LABEL],
                ]
                : data);
            var rangeData = addFallback(baseData, fallback);
            return encodeURIComponent(rangeData.join(separator));
        },
    };
};
export default rangeParser;
//# sourceMappingURL=range-parser.js.map